import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableSwitchAndSaveRateRecommendations = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableSwitchAndSaveRateRecommendations);
};
